import Banner from './Banner'
import Header from './Header'
import Benefits from './Benefits'
import Plans from './Plans';
import FeedbackCustomer from './FeedbackCustomer';
import Leads from '../../components/leads/Leads';
import Footer from './Footer';
import ButtonWhatsapp from '../../components/button-whatsapp/ButtonWhatsapp';

function Home() {
    return (
        <div>
            <Header></Header>
            <Banner></Banner>
            <Benefits></Benefits>
            <Plans></Plans>
            <FeedbackCustomer></FeedbackCustomer>
            <Leads></Leads>
            <Footer></Footer>
            <ButtonWhatsapp></ButtonWhatsapp>
        </div>
    );
}
export default Home;